<script>
//import * as SurveyVue from 'survey-vue';
export default {
    extends: app.base.attachmentHelper,
    props: {
        form_submission_id: {
            default: null
        },
        user: {
            default: null
        }
    },
    data: function(){
        return {
            errors: [],
            survey: null,
            inline_errors: [],
            form_submission: null,
            results: null,
            originalData: false,
            initialised: false,
			complete_button_key: 1,
            keywords: null,
            keyword_question: null,
            signpost_enabled: false,
            signpost_items_visible: false,
            signpost_submission_id: null,
        }
    },
    watch: {
        "$route.params.id": {
            handler: function(newId, oldId) {
                this.errors = [];
                this.survey = null;
                this.form_submission = null;
                this.results = null;
                this.originalData = false;
                this.initialised = false;
			    this.complete_button_key = 1;
                this.keywords = null;
                this.keyword_question = null;
                this.signpost_items_visible = false;
                this.signpost_submission_id = null;
                this.init();
            }
        },
        "survey.data": {
            handler: function() {
                
                if(this.environment_settings.MIX_ENABLE_CACHE && this.initialised) {
                    //console.log("Saving draft");
                    if(this.survey.data) {
                        if(this.environment_settings.MIX_CACHE_ATTACHMENTS) {
                            this.eSetItem('in_progress_form', this.survey.data, this.encryptUniqueKey);
                            //this.eSetItem('in_progress_form_attached_documents', this.attached_documents, this.encryptUniqueKey);
                            //this.eSetItem('in_progress_form_attached_images', this.attached_images, this.encryptUniqueKey);
                            
                        }
                        else {
                            var stripped_data = JSON.parse(JSON.stringify(this.survey.data));
                            for(var index in stripped_data) {
                                stripped_data[index].attached_images = [];
                                stripped_cache[index].attached_documents = [];
                                // for(var index_a in stripped_cache[index].attached_images) {
                                    
                                // }
                                // for(var index_a in stripped_cache[index].attached_documents) {
                                    
                                // }
                            }
                            this.eSetItem('in_progress_form', stripped_data, this.encryptUniqueKey);
                        }
                    }
                    else {
                        this.eRemoveItem('in_progress_form', this.encryptUniqueKey);
                        //this.eRemoveItem(`in_progress_form_attached_images`, this.encryptUniqueKey);
                        //this.eRemoveItem(`in_progress_form_attached_documents`, this.encryptUniqueKey);
                    }
                }
            },
            deep: true
        },
    },
    
    mounted() {
        this.init();
    },
    unmounted() {
        this.$root.back_handler = null;
    },
    computed: {
        fs_id: function() {
            if(this.form_submission_id) {
                return this.form_submission_id;
            }
            else {
                return this.$route.params["id"]
            }
        },
        form_user: function() {
            if(this.user) {
                return this.user;
            }
            else if(this.form_submission.user_id) {
                return this.getCaree(this.form_submission.user_id);
            }

        },
        filtered_users() {
            var filteredUsers = this.$root.lookup.staff.filter(staff => {
                //return this.site_id == "" || this.userHasSiteAvailability(staff, this.site_id);
                if(this.is_patient()) {
                    return staff.available && (!this.$root.user.provider.site_id || this.userHasSiteAvailability(staff, this.$root.user.provider.site_id));
                }
                else {
                    return this.isMemberOfAssignableGroup(staff);
                }
            
                
            });

            filteredUsers.sort((staff1, staff2) => {
                return this.formatSurname(staff1).localeCompare(this.formatSurname(staff2));
            });
            return filteredUsers;
        },

    },
    beforeRouteUpdate (to, from, next) {
        this.checkRouteChange(to, from, next);
    },
    beforeRouteLeave(to, from, next) {
        this.checkRouteChange(to, from, next);
    },
    methods: {
        nextPage() {
            if(this.signpost_items_visible) {
                this.signpost_items_visible = false;
                this.survey.nextPage();
            }
            if(this.signpost_enabled && this.survey && this.survey.currentPage) {
                this.keyword_question = this.survey.currentPage.questions.find(obj => {return obj.name.match(/___AMGKL__CUSTOM_ACTION_SUGGESTION___/)});
                if(this.keyword_question && this.survey.data[this.keyword_question.name]) {
                    this.keywords = this.survey.data[this.keyword_question.name];

                    this.setLoading(true);
                    this.$refs.custom_action_selector.setSignpostFilter(this.keywords)
                    .then(() => {
                        //if(!this.signpost_items_completed) {
                        var signpost_items = this.$refs.custom_action_selector.getVisibleItems();
                        //console.log(signpost_items);
                        this.setLoading(false);
                        if(signpost_items.length) {
                            this.signpost_items_visible = true;
                        }
                        else {
                            this.survey.nextPage();
                        }
                        
                    })
                    .catch((error) => {
                        console.error(error);
                        this.setLoading(false);
                        // If anything goes wrong, just let the user go to to the next form page.
                        this.survey.nextPage();    
                    });
                }
                else {
                    this.survey.nextPage();
                }
            }
            else {
                this.survey.nextPage();
            }
        },
        goBack() {
            if(this.signpost_items_visible) {
                this.signpost_items_visible = false;
            }
            else if(this.survey && !this.survey.isFirstPage) {
                this.survey.prevPage();
            }
            else {
                this.$root.$router.back();
                // window.history.go(-1);
            }
            return false;
        },
        checkRouteChange(to, from, next) {
            this.checkUnsaved(this.originalData, this.survey.data, to, from, next);
        },
        loadThumbnail(image, element) {
            return axios.get(this.$root.apiBase + '/formsubmissionimage/thumb/' + image.image.id + (this.form_submission.archived ? "/1" : ""), { responseType: 'arraybuffer' }).then((res) => {

                let imageR = btoa(
                    new Uint8Array(res.data)
                        .reduce((data, byte) => data + String.fromCharCode(byte), '')
                );
                var image_data = {id: image.image.id, tn_width: image.image.tn_width, tn_height: image.image.tn_height, width: image.image.width, height: image.image.height, data: null, tn_data: `data:${res.headers['content-type'].toLowerCase()};base64,${imageR}`}
                this.image_data.push(image_data);
                element.content = image_data.tn_data;
                Promise.resolve(image_data);
            }).catch((error) => {
                //console.log(error);
                Promise.reject(error);
            });
        },
		loadFull(image, element) {
            return axios.get(this.$root.apiBase + '/formsubmissionimage/' + image.image.id + (this.form_submission.archived ? "/1" : ""), { responseType: 'arraybuffer' }).then((res) => {

                let imageR = btoa(
                    new Uint8Array(res.data)
                        .reduce((data, byte) => data + String.fromCharCode(byte), '')
                );
                var image_data = {id: image.image.id, tn_width: image.image.tn_width, tn_height: image.image.tn_height, width: image.image.width, height: image.image.height, tn_data: null, data: `data:${res.headers['content-type'].toLowerCase()};base64,${imageR}`}
                this.image_data.push(image_data);
                element.content = image_data.data;
                Promise.resolve(image_data);
            }).catch((error) => {
                //console.log(error);
                Promise.reject(error);
            });
        },
        loadImageRaw(image, element, index) {
            return axios.get(this.$root.apiBase + '/formsubmissionimage/' + image.image.id + (this.form_submission.archived ? "/1" : ""), { responseType: 'arraybuffer' }).then((res) => {

                let imageR = btoa(
                    new Uint8Array(res.data)
                        .reduce((data, byte) => data + String.fromCharCode(byte), '')
                );
                var image_data = {id: image.image.id, width: image.image.width, height: image.image.height, data: `data:${res.headers['content-type'].toLowerCase()};base64,${imageR}`, tn_data: null}
                this.image_data.push(image_data);
                element[index] = image_data.data;
                Promise.resolve(image_data);
            }).catch((error) => {
                //console.log(error);
                Promise.reject(error);
            });
        },
        loadDocument(document, element) {
            return axios.get(this.$root.apiBase + '/formsubmissiondocument/' + document.document.id + (this.form_submission.archived ? "/1" : ""), { responseType: 'arraybuffer' }).then((res) => {

                let documentR = btoa(
                    new Uint8Array(res.data)
                        .reduce((data, byte) => data + String.fromCharCode(byte), '')
                );
                var document_data = {id: document.document.id, data: `data:${res.headers['content-type'].toLowerCase()};base64,${documentR}`}
                this.document_data.push(document_data);
                element.content = document_data.data;
                Promise.resolve(document_data);
            }).catch((error) => {
                // console.log(error);
                Promise.reject(error);
            });
        },
        // https://adamb-dev-nhs.askmygp.uk/#/form/1/23478/19838
        process_element(obj) {
            if(obj.type == "file") {
                obj.storeDataAsText = false;
            }
            if(Array.isArray(obj.choices)) {
                for(var arrindex = obj.choices.length - 1; arrindex >= 0; arrindex--) {
                    if(obj.choices[arrindex] == "___AMGDATA__AVAILABLE_CLINICIANS___") {
                        obj.choices.splice(arrindex);
                        // @TODO If the form has been completed, artificially populate this with the selected
                        // user instead of the full list
                        if(this.form_submission.submitted_at) {
                            var result = this.find_result(obj.name);
                            if(result) {
                                obj.choices.push({
                                    "value": result.value,
                                    "text": result.displayValue
                                });
                            }
                            else {
                                obj.choices.push({
                                    "value": -1,
                                    "text": "ERROR: NO RESULT FOUND IN SUBMISSION"
                                });
                            }
                        }
                        else {
                            for(var index in this.filtered_users) {
                                var name = this.formatClinician(this.filtered_users[index]);
                                
                                obj.choices.push({
                                    "value": this.filtered_users[index].id,
                                    "text": name
                                });
                                
                            }
                        }
                    }
                    if(
                        (
                            typeof obj.choices[arrindex] == "object" 
                            && (
                                ("" + obj.choices[arrindex].value).includes("___AMGDATA__IF_CLINICIAN_GENDER_SELECTION_TRUE___") 
                                || ("" + obj.choices[arrindex].text).includes("___AMGDATA__IF_CLINICIAN_GENDER_SELECTION_TRUE___")
                            )
                        ) 
                        || ( 
                            ("" + obj.choices[arrindex]).includes("___AMGDATA__IF_CLINICIAN_GENDER_SELECTION_TRUE___")
                        )
                    ) {
                        if(!this.$root.provider.clinician_gender_selection_enabled) {
                            obj.choices.splice(arrindex, 1);
                        }
                    }
                }
            }
        },
        init() {
            var promises = [];

            this.setLoading(true);
            
            axios.get(this.$root.apiBase + "/formsubmissions/" + this.fs_id + (this.$route.params["archive"] ? "/1" : "")).then(res => {
                this.form_submission = res.data;
                this.initEncryptStorageLocal();

                // ADD IN THUMBNAIL AND DOCUMENT LOADING WITH A promise.all (need to do this before injecting the 
                // content.results back in to the survey).

                // Parse the JSON content blocks 
                if(this.form_submission.content) {
                    this.form_submission.content = JSON.parse(this.form_submission.content);

                    // Add the image and document data back in from the attachments.
                    if(this.form_submission.content) {
                        for(var index in this.form_submission.content.results) {
                            if(Array.isArray(this.form_submission.content.results[index])) {
                                for(var content_index in this.form_submission.content.results[index]) {
                                    if(typeof this.form_submission.content.results[index][content_index] == "object") {
                                        if(this.form_submission.content.results[index][content_index].image_id) {
                                            var image = this.form_submission.form_submission_image.find(obj => {return obj.image_id == this.form_submission.content.results[index][content_index].image_id});
                                            if(image) {
                                                //promises.push(this.loadThumbnail(image, this.form_submission.content.results[index][content_index]));
												promises.push(this.loadFull(image, this.form_submission.content.results[index][content_index]));
                                            }
                                        }
                                        else if(this.form_submission.content.results[index][content_index].document_id) {
                                            var document = this.form_submission.form_submission_document.find(obj => {return obj.document_id == this.form_submission.content.results[index][content_index].document_id});
                                            if(document) {
                                                promises.push(this.loadDocument(document, this.form_submission.content.results[index][content_index]));
                                            }
                                        }
                                    }
                                }
                            }
                            else if (this.form_submission.content.results[index].image_id) {
                                var image = this.form_submission.form_submission_image.find(obj => {return obj.image_id == this.form_submission.content.results[index].image_id});
                                if(image) {
                                    //console.info(this.form_submission.content.results[index]);
                                    promises.push(this.loadImageRaw(image, this.form_submission.content.results, index));
                                }
                            }
                        }
                    }
                }
                
                Promise.all(promises).then(() => {
                    if(this.form_submission.form_version && this.form_submission.form_version.content) {
                        this.form_submission.form_version.content = JSON.parse(this.form_submission.form_version.content);
                        
                        // Turn off the file storeDataAsText for any upload elements as we handle these ourselves
                        if(this.form_submission.form_version.content.pages) {
                            this.form_submission.form_version.content.pages.forEach(page => {
                                if(page.elements && Array.isArray(page.elements)) {
                                    page.elements.forEach(obj => {
                                        this.process_element(obj);
                                    })
                                }
                            });    
                        }
                        else if(this.form_submission.form_version.content.elements) {
                            this.form_submission.form_version.content.elements.forEach(obj => {
                                this.process_element(obj);
                            });
                        }
                        //console.log(JSON.stringify(this.form_submission.form_version.content, null, 2));
                    }

                    window.Survey
                        .StylesManager
                        .applyTheme("defaultV2");
                    
                    
                    
                    this.survey = new window.Survey.Model(this.form_submission.form_version.content);
                    if(this.tBrandSetting("conf_surveyjs_question_heading_tag")) {
                        window.Survey.settings.titleTags.question = this.tBrandSetting("conf_surveyjs_question_heading_tag");
                    }
                    
                    if(this.form_submission.content) {
                        this.survey.data = this.form_submission.content.results;
                    }

                    if(this.form_submission.submitted_at) {
                        this.survey.mode = 'display';
                    }

                    // this.survey.onGetTitleTagName.add((_, options) => {
                    //     console.info(options);
                    //     options.tagName = "h1";
                    //     // Use <h4> instead of <h3> for questions nested in panels
                    //     const parent = options.element.parent;
                    //     if (!!parent && parent.isPanel) {
                    //         options.tagName = "h4";
                    //     }
                    // });

                    this.loadFromLocalStorage().then(() => {
                        this.originalData = JSON.parse(JSON.stringify(this.survey.data));
                        this.survey.showCompletedPage = false;
                        this.survey.onComplete.add(this.submit);
                        this.survey.onCompleting.add(this.completing);
                        //this.survey.onCurrentPageChanged.add(this.doOnCurrentPageChanged);
                        this.survey.onUploadFiles.add(this.handleFileUpload);
                        this.survey.onClearFiles.add(this.handleFileClear);
                        //this.survey.onDownloadFile.add(this.handleFileDownload);
                        
                    //    this.survey.onAfterRenderSurvey.add(this.addScrollToEndFunction);
                        //this.doOnCurrentPageChanged(this.survey);
                        this.setLoading(false);
                        this.initialised = true;
                        
                        // this.$refs.editScroller.onscroll = () => {
                        //     this.$refs.editScroller.scrollTop = 0;
                        //     this.$refs.editScroller.onscroll = null;
                        //     console.log("SCROLL!!!!");
                        //     console.log(this.$refs.editScroller);
                        // };
                         
                        // this.$nextTick(() => {
                        //     this.$nextTick(() => {
                        //         this.$refs.editScroller.scrollTop = 0;
                        //         console.log("SCROLL!!!!");
                        //         console.log(this.$refs.editScroller);
                        //     });
                        // });
                    });
                    this.$root.back_handler = this.goBack;
                    
                });
            })
            .catch(error => {
                this.setLoading(false);
                this.handleError(error, "form");
            });
        },
        find_result(name) {
            var $match = false;
            //console.info(`Looking for ${name}`);
            if(this.form_submission.content && typeof this.form_submission.content.readable == "object") {
                //console.info(`PASS`);
                Object.keys(this.form_submission.content.readable).forEach(index => {
                    //console.info(`Looking at ${index}`);
                    if(index == name) {
                        $match = this.form_submission.content.readable[index];
                    }
                })
            }
            return $match;
        },
        handleFileUpload(sender, options) {
            // https://www.surveyjs.io/Examples/Library?id=questiontype-file&platform=Reactjs&theme=defaultV2
            //console.info(options);
            this.getAttachment({target: {files: options.files}}, options.name).then(attachment_data => {
                options.files.forEach(file => {
                    var attachment = attachment_data.find(obj => {return obj.file_name == file.name});
                    if(attachment) {
                        options.callback("success", [{
                            file: file,
                            //content: attachment.tn_data_url ? attachment.tn_data_url : attachment.data_url,
							content: attachment.data_url,
							/**
							 * @todo This doesn't work, which is annoying. We will need to update the filenames, and types
							 * server side.
							 */
							//type: 'image/png',
                        }]);
                    }
                    else {
                        options.callback("error", [{
                            file: file,
                        }]);
                    }
                });
                
            });
            
        },
        handleFileClear(sender, options) {
            // https://www.surveyjs.io/Examples/Library?id=questiontype-file&platform=Reactjs&theme=defaultV2
            //console.info(options);

            var attachment_index = -1;
            do {
                var attachment_index = this.attached_images.findIndex(obj => {
                    if(options.fileName) {
                        return obj.file_name == options.fileName;
                    }
                    else {
                        // Delete all
                        return obj.question_name == options.name;
                    }
                });
                if(attachment_index !== -1) {
                    this.attached_images.splice(attachment_index, 1);
                }
                else {
                    var attachment_index = this.attached_documents.findIndex(obj => {
                        if(options.fileName) {
                            return obj.question_name == options.name && obj.file_name == options.fileName;
                        }
                        else {
                            // Delete all
                            return obj.question_name == options.name;
                        }
                    });
                    if(attachment_index !== -1) {
                        this.attached_documents.splice(attachment_index, 1);
                    }
                }

            }
            while(attachment_index !== -1)
            options.callback("success");
        },
        handleFileDownload(survey, options) {
            // console.info(options);
            return;
            var xhr = new XMLHttpRequest();
            xhr.open("GET", "https://api.surveyjs.io/private/Surveys/files?name=" + options.content);
            xhr.onloadstart = function (ev) {
                xhr.responseType = "blob";
            }
            xhr.onload = function () {
                var file;
                if (detectIEOrEdge()) {
                    file = new Blob([xhr.response], options.fileValue.name, {type: options.fileValue.type});
                } else {
                    file = new File([xhr.response], options.fileValue.name, {type: options.fileValue.type});
                }
                var reader = new FileReader();
                reader.onload = function (e) {
                    options.callback("success", e.target.result);
                };
                reader.readAsDataURL(file);
            };
        },
        addScrollToEndFunction(survey, options) {
            this.survey.onAfterRenderQuestion.add(this.scrollToEnd);
        },
        scrollToEnd(survey, options) {
            options.htmlElement.scrollIntoView();
            // console.info("!!!!!!", options);
            // if(this.$el && this.$el.querySelector) {
            //     var container = this.$el.querySelector(".scroller");
            //     if(container) {
            //         container.scrollTop = container.scrollHeight;
            //     }
            // }
        },
        submit(sender, options) {
            
        },
        renderReadableAnswers(survey) {
            var output = {};
            var questions = survey.getAllQuestions()
            for(var index in questions) {
                var questionName = questions[index].name;
                var question = survey.getQuestionByValueName(questionName);
                if(question) {
                    var item = question.getPlainData();
                    
                    if(typeof item.value != "undefined") {
                        output[questionName] = item;

                        output[questionName].plain = "(" + item.name + ") " + item.title + (item.title.endsWith(":") ? " " : ": ");
                        if(question.inputType == "date") {
                            if(item.value) {
                                var date = this.moment(item.value)
                                if(date.isValid()) {
                                    output[questionName].plain += date.format('DD/MM/YYYY');
                                }
                            }
                        }
                        else if(question.signaturePad) {
                            if(item.name && item.value) {
                                output[questionName].plain += `${questionName}.png`;
                                item.displayValue = null;
                                item.value = null;
                                //output[questionName].value = null;
                            }
                        }
                        else if(Array.isArray(item.displayValue)) {
                            var firstItem = true;
                            for(var index in item.displayValue) {
                                if(!firstItem) {
                                    output[questionName].plain += ", ";
                                }
                                else {
                                    firstItem = false;
                                }
                                // This is an upload
                                if(item.displayValue[index].name && item.displayValue[index].type) {
                                    output[questionName].plain += item.displayValue[index].name;
                                    item.displayValue[index].content = null;
                                }
                                // Otherwise just display each element in the object
                                else {
                                    output[questionName].plain += JSON.stringify(item.displayValue[index]);
                                }
                            }

                            // We unset the content for uploads as it is too big (base64 encoded image data),
                            // and we send the data in binary in the multipart-form, so we don't need it.
                            if(Array.isArray(item.value)) {
                                for(var index in item.data) {
                                    if(item.value[index].content) {
                                        item.value[index].content = null;
                                    }
                                }
                            }
                            if(Array.isArray(item.data)) {
                                for(var index in item.data) {
                                    item.data[index].value = null;
                                }
                            }
                            
                        }
                        else if(typeof item.displayValue == "object") {
                            var firstItem = true;
                            for(var index in item.displayValue) {
                                if(!firstItem) {
                                    output[questionName].plain += ", ";
                                }
                                else {
                                    firstItem = false;
                                }
                                output[questionName].plain += index + " = " + item.displayValue[index] + (item.displayValue[index] != item.value[index] ? " [" + item.value[index] + "]" : "");
                            }
                        }
                        else {
                            output[questionName].plain += item.displayValue + (item.displayValue != item.value ? " [" + item.value + "]" : "");
                        }
                    }
                }
            }
            
            return output;
        },
        checkFormUpdateTime(next) {
            axios.get(this.$root.apiBase + "/formsubmissions/" + this.fs_id + (this.$route.params["archive"] ? "/1" : "")).then(res => {
                if(this.form_submission.updated_at < res.data.updated_at) {
                    this.$modal.show('dialog', {
                        title: "Form Submission",
                        text: "This form has been updated by another user since you opened it for editing. Do you want to save your changes over the previous form submission?",
                        buttons: [
                        {
                            title: this.$t('translations.yes'),
                            handler: () => {
                                this.$modal.hide('dialog');
                                next();
                            },
                        },
                        {
                            title: this.$t('translations.cancel'),
                            handler: () => {
                                this.$modal.hide('dialog');
                            }
                        }]});
                }
                else {
                    next();
                }
            })
            .catch(error => {
                this.handleError(error, "form");
            });
                

        },
        preprocess_result_data() {
            this.results = this.copyNonReactive(this.survey.data);

            Object.keys(this.results).forEach(key => {
                if(Array.isArray(this.results[key])) {
                    this.results[key].forEach(sub_answer => {
                        if(typeof sub_answer == "object") {
                            if(sub_answer.type && sub_answer.content) {
                                sub_answer.content = null;
                            }
                        }
                    })
                }
                else if(typeof this.results[key] == "string" && this.results[key].startsWith("data:image/png;base64")) {
                    var attachment_name = `${key}.png`;
                    var attachment_data = this.results[key];

                    var image_data = {
                        file_name: attachment_name, 
                        file_type: "image/png", 
                        data_url: attachment_data,
                        question_name: key,
                    };
                    
                    this.attached_images.push(image_data);

                    this.results[key] = {
                        "name": `${key}.png`,
                        "type": "image/png",
                        "content": null
                    };
                }
                
                else if(typeof this.results[key] == "object") {
                    if(this.results[key].type && this.results[key].content) {
                        this.results[key].content = null;
                    }
                }
                
            });
        },
        completing(sender, options) {
            options.allowComplete = false;
            
            this.preprocess_result_data();
            
            var data = {
                content: {
                    results: this.results,
                    readable: this.renderReadableAnswers(sender),
                },
                complete: true,
            }
            data["attached_images"] = this.attached_images;
            data["attached_documents"] = this.attached_documents;
            //console.log(JSON.stringify(data, null, 2));
            this.checkFormUpdateTime(() => {
                this.setLoading(true);
                var form = this.objectToFlatForm(data, "question_name");
                // Should be a PUT. See notes in api.php.
                axios.post(this.$root.apiBase + "/formsubmissions/" + this.form_submission.id
                        , form
                        , {headers: {'Content-Type': 'multipart/form-data' }}).then(res => {
                    if(this.form_submission.message_id != res.data.form_submission.message_id) {
                        var new_thread = true;
                    }
                    this.form_submission = res.data.form_submission;
                    this.originalData = null;
                    this.closeSurvey(new_thread);

                    this.addNotification({type: "success", content: this.$t("translations.form_submitted_successfully")});
                })
                .catch(error => {
					this.complete_button_key++;
                    this.setLoading(false);
                    this.handleError(error, "form");
                    this.$refs.editScroller.scrollTop = 0;
                });
            });
        },
        saveProgress() {
            this.preprocess_result_data();

            Object.keys(this.results).forEach(key => {
                if(Array.isArray(this.results[key])) {
                    this.results[key].forEach(sub_answer => {
                        if(typeof sub_answer == "object") {
                            if(sub_answer.type && sub_answer.content) {
                                sub_answer.content = null;
                            }
                        }
                    })
                }
                else if(typeof this.results[key] == "string" && this.results[key].startsWith("data:image/png;base64")) {
                    this.results[key] = {
                        "name": `${key}.png`,
                        "type": "image/png",
                        "content": null
                    };
                }
                else if(typeof this.results[key] == "object") {
                    if(this.results[key].type && this.results[key].content) {
                        this.results[key].content = null;
                    }
                }
            });
            var data = {
                content: {
                    results: this.results,
                    readable: this.renderReadableAnswers(this.survey),
                }
            }
            data["attached_images"] = this.attached_images;
            data["attached_documents"] = this.attached_documents;

            //console.info(JSON.stringify(data.results, null, 2));
            //console.info(JSON.stringify(data.attached_images[0], null, 2));
            this.checkFormUpdateTime(() => {
                this.setLoading(true);
                var form = this.objectToFlatForm(data, "question_name");
                //console.info(JSON.stringify(form, null, 2));
                // Should be a PUT. See notes in api.php.
                axios.post(this.$root.apiBase + "/formsubmissions/" + this.form_submission.id
                        , form
                        , {headers: {'Content-Type': 'multipart/form-data' }}).then(res => {
                    this.form_submission = res.data.form_submission;
                    this.originalData = null;
                    this.closeSurvey()

                    this.addNotification({type: "success", content: this.$t("translations.form_progress_saved")});
                })
                .catch(error => {
                    this.setLoading(false);
                    this.handleError(error, "form");
                    this.$refs.editScroller.scrollTop = 0;
                });
            });
        },
        closeSurvey(new_thread = false) {
            this.eRemoveItem('in_progress_form', this.encryptUniqueKey);
            this.eRemoveItem(`in_progress_form_attached_images`, this.encryptUniqueKey);
            this.eRemoveItem(`in_progress_form_attached_documents`, this.encryptUniqueKey);

            if(this.is_staff()) {
                if(new_thread) {
                    this.$router.push({path: "/thread-list/thread-show/" + this.form_submission.message.thread.id + (this.$route.params["archive"] ? "/1" : "")});
                }
                else if(this.form_submission_id) {
                    this.$emit("close");
                }
                else if(this.form_submission.message) {
                    this.$router.push({path: "/thread-list/thread-show/" + this.form_submission.message.thread.id + (this.$route.params["archive"] ? "/1" : "")});
                }
                else {
                    this.$router.push({path: "/home"});
                }
            }
            else {
                if(this.form_submission_id) {
                    this.$emit("close");
                }
                else if(this.form_submission.message) {
                    this.$router.push({path: "/thread-show/" + this.form_submission.message.thread.id + (this.$route.params["archive"] ? "/1" : "")});
                }
                else {
                    this.$router.push({path: "/profile"});
                }
            }

        },
        cancel() {
            this.checkUnsaved(this.originalData, this.survey.data, null, null,() => 
            {
                this.originalData = null;
                this.closeSurvey();
            });
        },
        // This one was embedded in another example page
        saveSurveyToPdf(filename, survey, pdfWidth, pdfHeight) {
            var options = {
                fontSize: 14,
                margins: {
                    left: 10,
                    right: 10,
                    top: 10,
                    bot: 10
                },
                format: [pdfWidth, pdfHeight]
            };
            var surveyPDF = new SurveyPDF.SurveyPDF(json, options);
            surveyPDF.data = surveyModel.data;
            surveyPDF.save(filename);
        },
        // This is from the example on surveyJS
        //    https://surveyjs.io/Examples/Pdf-Export#content-js
        // Probably just need the one above - and move it to MessageList
        savePdfCallback() {
            const options = {
                fontSize: creator.survey.pdfFontSize,
                fontName: creator.survey.pdfFontName,
                margins: {
                    left: creator.survey.pdfMarginLeft,
                    right: creator.survey.pdfMarginRight,
                    top: creator.survey.pdfMarginTop,
                    bot: creator.survey.pdfMarginBottom
                },
                htmlRenderAs: creator.survey.pdfHtmlRenderAs,
                matrixRenderAs: creator.survey.pdfMatrixRenderAs,
                compress: creator.survey.pdfCompress
            };
            if (creator.survey.pdfOrientation !== "auto") {
                options.orientation = creator.survey.pdfOrientation;
            }
            if (creator.survey.pdfFormatType === "custom") {
                options.format = [creator.survey.pdfFormatWidth, creator.survey.pdfFormatHeight]
            } else if (creator.survey.pdfFormatType !== "default") {
                options.format = creator.survey.pdfFormatType;
            }
            const surveyPDF = new SurveyPDF.SurveyPDF(creator.JSON, options);
            surveyPDF.data = creator.surveyLiveTester.survey.data;
            surveyPDF.mode = creator.survey.pdfMode;
            surveyPDF
                .onRenderQuestion
                .add(function (_, options) {
                    options
                        .bricks[0]
                        .isPageBreak = options.question.pdfIsPageBreak;
                });
            surveyPDF.save(creator.survey.pdfFileName);
        },
        initEncryptStorageLocal() {
            this.encryptUniqueKey = this.$root.user.id + "-" + this.form_submission.id;
        },
        loadDraftFromLocalStorage() {
            if(this.environment_settings.MIX_ENABLE_CACHE) {
                var in_progress_form = this.eGetItem(`in_progress_form`, this.encryptUniqueKey);
                // var in_progress_form_attached_images = this.eGetItem(`in_progress_form_attached_images`, this.encryptUniqueKey);
                // var in_progress_form_attached_documents = this.eGetItem(`in_progress_form_attached_documents`, this.encryptUniqueKey);

                if(in_progress_form && typeof in_progress_form == "object" && Object.keys(in_progress_form).length) {
                    //console.info("Loading draft");
                    this.survey.data = in_progress_form;
					for(var answer in in_progress_form) {
						for(var page of this.survey.pages) {
							for(var question of page.questions) {
								if(question.name == answer) {
									console.log(`Recreating attachment for localStorage item: ${answer}`);
									//console.log(JSON.stringify(in_progress_form[answer], null, 2));
									//console.log(JSON.stringify(question, null, 2));

									if(Array.isArray(in_progress_form[answer])) {
										for(var index in in_progress_form[answer]) {
											if(typeof in_progress_form[answer][index] == "object" && typeof in_progress_form[answer][index]["type"] == "string" && in_progress_form[answer][index]["type"].match(/^image\//)) {
												//console.log(JSON.stringify(in_progress_form[answer][index], null, 2));
												//console.log(in_progress_form[answer][index]["name"]);
												
												var image = new Image();
												var that = this;
												image.addEventListener('load', function() {
													//console.log(this);
													//console.info(this.extra);
													//console.info(index);
													var tn_canvas = that.resizeImage(this, 100, 100);
													var resize_canvas = that.resizeImage(this, 1000, 1000);
													
													var image_data = {
														file_name: this.extra["name"],
														file_type: this.extra["type"],
														data_url: this.extra["content"],
														question_name: this.extra["answer"],
														tn_canvas: tn_canvas, 
														resize_canvas: resize_canvas, 
														tn_data_url: tn_canvas.toDataURL("image/png"), 
														data_url: resize_canvas.toDataURL("image/png"),
													}
													console.log("Pushing image_data on to attached_images", this.extra["name"]);
													that.attached_images.push(image_data);
												});
												// Copy this locally so that it doesn't get overwritten
												// in a race condition (AV3-2138 additional bug right here)
												image.extra = in_progress_form[answer][index];
												image.extra["answer"] = answer;
												image.src = in_progress_form[answer][index]["content"];
											}
											
										}
									}
									
                                }
							}
						}
					}
                }
            }
        },
        loadFromLocalStorage() {
            return new Promise((resolve, reject) => {
                //this.loadDraftFromLocalStorage();
                if(this.environment_settings.MIX_ENABLE_CACHE) {
                    var in_progress_form = this.eGetItem('in_progress_form', this.encryptUniqueKey);
                    //console.warn(in_progress_form, typeof in_progress_form, typeof in_progress_form == "object" ? Object.keys(in_progress_form).length : "not object");
                    if(in_progress_form && typeof in_progress_form == "object" && Object.keys(in_progress_form).length) {
                        this.$modal.show('dialog', {
                            title: this.$t('translations.recover_in_progress_form_title'),
                            text:  '<span role="alert" tabindex="0" aria-live="polite">' + this.$t('translations.recover_in_progress_form_text') + '</span>',
                            buttons: [
                            {
                                title: this.$t('translations.yes'),
                                handler: () => {
                                    this.$modal.hide('dialog');
                                    this.loadDraftFromLocalStorage();
                                    resolve(true);
                                },
                            },
                            {
                                title: this.$t('translations.no'),
                                handler: () => {
                                    this.$modal.hide('dialog');
                                    this.eRemoveItem('in_progress_form', this.encryptUniqueKey);
                                    this.eRemoveItem(`in_progress_form_attached_images`, this.encryptUniqueKey);
                                    this.eRemoveItem(`in_progress_form_attached_documents`, this.encryptUniqueKey);

                                    resolve(false);
                                }
                            }]});
                    }
                    else {
                        resolve(false);
                    }
                }
                else {
                    resolve(false);
                }
            });
        },
		completeLastPageWrapper() {
			/**
			 * Looks like the newer API has survey.valid():
			 *
			 *	   https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#validate
			 */
			//console.warn(this.complete_button_key);
			this.setLoading(true);
			
			Vue.nextTick(() => {
				if(!this.survey.validate()) {
					this.complete_button_key++;
					this.setLoading(false);
				}
				else {
					this.survey.tryComplete();
				}
			});
		}
    }
}
</script>

